import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { HelperService } from '../../services/helper.service';

@Component({
  selector: 'app-view-ring-prescription',
  templateUrl: './view-ring-prescription.component.html',
  styleUrl: './view-ring-prescription.component.scss'
})
export class ViewRingPrescriptionComponent {
  details: any;
  DrugList: any[] = [];
  constructor(
    public dialogRef: MatDialogRef<ViewRingPrescriptionComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public toastr: ToastrService,
    public helperService: HelperService
  ) { }

  ngOnInit() {
    // Initialization logic here
    this.details = this.data?.item || {};
    this.DrugList = this.data?.item?.drugs_ai || [];
  }

  openPdf(details: any) {
    if (details.azure_file_path) {
      window.open(details.azure_file_path, '_blank')
    } else {
      this.toastr.error('PDF file not available');
    }
  }

}
